// eslint-disable-next-line
export default (states: any = {}, action: any) => {
  switch (action.type) {
    default:
      return states;
  }
};
